import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
} from '@fluentui/react-components'
import { ProjektprognosErrorModal } from './ProjektprognosErrorModal'
import { useEffect, useState } from 'react'
import { useProjektprognosInteractionContext } from '../context/ProjektprognosInteractionContext'
import { DismissRegular } from '@fluentui/react-icons'

// used on if error is partial or when caused by a user action
export const ProjektprognosErrorBar = () => {
  const [displayMessageBar, setDisplayMessageBar] = useState<boolean>(true)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const { errors, setErrors } = useProjektprognosInteractionContext()

  useEffect(() => {
    if (errors?.length > 0) {
      setDisplayMessageBar(true)
    } else {
      setDisplayMessageBar(false)
    }
  }, [errors?.length])

  if (displayMessageBar) {
    const latestError = errors[errors.length - 1]
    const fullErrorMessage = latestError?.message || 'Ett okänt fel uppstod'

    const userFriendlyMessage =
      fullErrorMessage.split(': ')[0] || fullErrorMessage
    const hasMultipleErrors = errors.length > 1

    return (
      <>
        <MessageBar intent="error" style={{ margin: 8 }}>
          <MessageBarBody>
            <MessageBarTitle style={{ marginRight: 10 }}>
              Något gick fel
            </MessageBarTitle>
            {userFriendlyMessage}
            {hasMultipleErrors && ` (+${errors.length - 1} fler fel)`}
          </MessageBarBody>

          <MessageBarActions
            containerAction={
              <Button
                aria-label="dismiss"
                appearance="transparent"
                icon={<DismissRegular />}
                onClick={() => setErrors([])}
              />
            }
          >
            <Button onClick={() => setIsModalOpen(true)}>Visa mer</Button>
          </MessageBarActions>
        </MessageBar>

        <ProjektprognosErrorModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      </>
    )
  }

  return <></>
}
